import type { SaveServiceEstimateInput, ServiceEstimateLine } from './types';

/**
 * Rechenlogik des Kostenvoranschlags -- eine Quelle der Wahrheit für Demo-Gateway und Supabase-RPC,
 * damit dieselben Zeilen/Summen entstehen. Der Kostenvoranschlag ist ein Angebot (kein Buchungssatz),
 * die Summen dürfen daher clientseitig berechnet werden; die spätere echte Rechnung rechnet erneut.
 */

export function calculateServiceEstimateLineNet(line: Omit<ServiceEstimateLine, 'netAmount'>): number {
  const quantity = Math.max(0, Number(line.quantity) || 0);
  const unitPrice = Math.max(0, Number(line.unitPrice) || 0);
  const discount = Math.min(100, Math.max(0, Number(line.discountPercent) || 0));
  return line.kind === 'text' ? 0 : Math.round(quantity * unitPrice * (1 - discount / 100) * 100) / 100;
}

export function priceServiceEstimateLines(lines: readonly Omit<ServiceEstimateLine, 'netAmount'>[]): ServiceEstimateLine[] {
  return lines.map((line) => ({ ...line, netAmount: calculateServiceEstimateLineNet(line) }));
}

export function calculateServiceEstimateTotals(lines: readonly ServiceEstimateLine[]): { netTotal: number; vatTotal: number; grossTotal: number } {
  const netTotal = Math.round(lines.reduce((sum, line) => sum + line.netAmount, 0) * 100) / 100;
  const vatTotal = Math.round(lines.reduce((sum, line) => sum + line.netAmount * line.vatRate / 100, 0) * 100) / 100;
  return { netTotal, vatTotal, grossTotal: Math.round((netTotal + vatTotal) * 100) / 100 };
}

export function validateServiceEstimateInput(input: SaveServiceEstimateInput): void {
  if (input.lines.length === 0) throw new Error('Ein Kostenvoranschlag benötigt mindestens eine Position.');
  if (input.lines.some((line) => !line.description.trim())) throw new Error('Jede Position benötigt eine Bezeichnung.');
  if (input.lines.some((line) => line.kind !== 'text' && (Number(line.quantity) || 0) <= 0)) {
    throw new Error('Berechenbare Positionen benötigen eine Menge größer als 0.');
  }
}
